import React, { useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { Workspace } from '@idealmediaworks/lookingglass-ui-framework';
import { useHierarchyStore } from '../../models';
import Message from '../../components/message/Message';
import Preloader from '../../components/preloader/Preloader';

const SchedulesPage: React.FC = (): JSX.Element => {
  const { selectedRegion, hasError, messageType, initSchedules } =
    useHierarchyStore();

  useEffect(() => {
    if (hasError) return;

    initSchedules();
  }, [hasError, initSchedules]);

  if (selectedRegion?.isLoading) {
    return <Preloader isFullPage message="Please wait" />;
  }

  if (hasError && messageType) {
    return <Message type={messageType} isFullPage />;
  }

  const layout = {
    version: '0.2.4',
    id: 'workspace-schedules',
    direction: 'row',
    panes: [
      {
        id: 'pane-side',
        size: 13,
        type: 'percent',
        layout: {
          id: 'grid-side',
          direction: 'column',
          panes: [
            {
              id: 'pane-regions',
              size: 15,
              type: 'percent',
              panels: ['panel-regions'],
            },
            {
              id: 'pane-brands',
              size: 35,
              type: 'percent',
              panels: ['panel-brands'],
            },
            {
              id: 'pane-channels',
              size: 50,
              type: 'percent',
              panels: ['panel-channels'],
            },
          ],
        },
      },

      {
        id: 'pane-aside',
        size: 18.89,
        type: 'percent',
        layout: {
          id: 'grid-aside',
          direction: 'column',
          panes: [
            {
              id: 'pane-heatmaps',
              size: 78.88,
              type: 'percent',
              panels: ['panel-heatmaps'],
            },
            {
              id: 'pane-stream',
              size: 21.12,
              type: 'percent',
              panels: ['panel-stream'],
            },
          ],
        },
      },
      {
        id: 'pane-content',
        size: 68.11,
        type: 'percent',
        layout: {
          id: 'grid-content',
          direction: 'column',
          panes: [
            {
              id: 'pane-days',
              size: 100,
              type: 'percent',
              panels: ['panel-days'],
            },
          ],
        },
      },
    ],
  };

  return <Workspace layout={layout} key={layout.id} />;
};

export default SchedulesPage;
